import moment from 'moment';

import { JournalManualDto } from '~modules/journal/model';
import { UserHelper } from '~modules/user/model';

type SessionItemType = {
	journal: JournalManualDto;
	onEnd: (id: number) => void;
};

export function SessionItem({ journal, onEnd }: SessionItemType) {
	const handleEdit = () => {
		onEnd(journal.user_id!);
	};

	return (
		<tr onClick={handleEdit}>
			<td>{moment(journal.start).format('DD.MM.YYYY HH:mm')}</td>
			<td>{UserHelper.getName(journal.user)}</td>
		</tr>
	);
}
